export class UpdateListProducts {
    action: string;
    nextStep: string;
    i: number;
    productIndex: number;
    catIndex: number;
    NextcatIndex: number;
    constructor(data) {
        this.action = data.action;
        this.nextStep = data.nextStep;
        this.i = data.i;
        this.productIndex = data.productIndex;
        this.catIndex = data.catIndex;
        this.NextcatIndex = data.NextcatIndex;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/update-list-products.ts